export const EXPERIENCE_FRAGMENT_TYPE = 'mi-aem-common-spa/components/experiencefragment';
